<template>
  <div>
    <div class="top-area">
      <div class="top-area-inner">
        <div class="top-area-left">
          <h1>SSCMS 网站云</h1>
          <p>网站云产品已下架，请尽快迁移；到期前依旧可以正常使用。</p>
          <div class="top-area-btn-group">
            <button type="button" class="el-button el-button--default is-disabled" disabled>
              <span>已下架</span>
            </button>
          </div>
        </div>
        <div class="top-area-right"></div>
      </div>
    </div>
    <section class="main-area">
      <ul class="main-list">
        <li class="main-item">
          <div class="main-item-left">
            <h1>一键部署</h1>
            <p>
              一键部署，即刻开通上线，
              <br />
              网站10分钟建成。
            </p>
          </div>
          <img
            src="/home/img/host-empty-index2.png"
            class="main-item-right"
            style="width: 734px; height: 261px"
          />
        </li>
        <li class="main-item">
          <div class="main-item-left">
            <h1>统一标准可迁移</h1>
            <p>
              可以将您的网站随时部署至本地服务器，
              <br />
              或从本地服务器部署至 SSCMS 网站云。
            </p>
          </div>
          <img
            src="/home/img/host-empty-index3.png"
            class="main-item-right"
            style="width: 731px; height: 287px"
          />
        </li>
        <li class="main-item">
          <div class="main-item-left">
            <h1>安全稳定高可用</h1>
            <p>
              基于云原生，高弹性，企业级高可用，
              <br />
              由官方专业技术人员维护服务器与数据库，
              <br />
              手动/自动备份，保障系统安全。
            </p>
          </div>
          <img
            src="/home/img/host-empty-index4.png"
            alt="证件照制作"
            class="main-item-right"
            style="width: 732px; height: 286px"
          />
        </li>
        <li class="main-item">
          <div class="main-item-left">
            <h1>开放的生态系统</h1>
            <p>
              秉承开源是基础软件的未来这一理念，
              <br />
              SSCMS 系统持续扩大开源社区影响力，
              <br />
              专注 CMS 研发及开源生态建设。
            </p>
          </div>
          <img
            src="/home/img/host-empty-index5.png"
            class="main-item-right"
            style="width: 732px; height: 285px"
          />
        </li>
        <li class="main-item">
          <div class="main-item-left"><h1>更多特色等您发现</h1></div>
          <div class="main-item-right">
            <div class="main-item-right-tag">
              <i class="iconfont icon-shoucang"></i>
              <h1>多种版本可选择</h1>
              <p>
                选择适合您的
                <br />
                SSCMS 网站云版本
              </p>
            </div>
            <div class="main-item-right-tag">
              <i class="iconfont icon-moban2"></i>
              <h1>大量的优质模板</h1>
              <p>
                所有模板均支持
                <br />
                PC/平板/手机端
              </p>
            </div>
            <div class="main-item-right-tag">
              <i class="iconfont icon-usinghelp"></i>
              <h1>完善的文档说明</h1>
              <p>
                SSCMS 网站云
                <br />
                文档中心
              </p>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <div class="home_footer">
      <div class="title">网站云产品已下架，请尽快迁移；到期前依旧可以正常使用。</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Empty',
});
</script>
